export default __webpack_public_path__ + "static/media/desc-bg-sm.1942c0b3.svg";